document.addEventListener('DOMContentLoaded', () => {
  const assetsUrl = window.supernovaDevSettings.assetsUrl.replace(/\/$/, '');

  console.log(assetsUrl);
  
  lottie.loadAnimation({
    container: document.getElementById('about-planet-animation'),
    renderer: 'svg',
    loop: true,
    autoplay: true,
    path: `${assetsUrl}/lottie/svg_planet_blink.json`,
  });
});